import styled from 'styled-components'

const StyledCurrentPlanCard = styled.div<{ plan?: string }>`
  .current-plan-main {
    margin: 20px 0 40px 0;
    border: 1px solid #797978;
    box-sizing: border-box;
    border-radius: 3px;

    .current-plan-gradient {
      height: 17px;
      padding: 0;

      ${({ plan }) => {
    switch (plan) {
      case 'Monthly':
        return `background: linear-gradient(135deg, rgba(249, 225, 180, 0.4) 2.88%, rgba(182, 224, 245, 0.4) 100%);`
      case 'Annual':
        return `background: linear-gradient(135deg, rgba(255, 172, 198, 0.4) 2.88%, rgba(182, 224, 245, 0.4) 100%);`
      case 'Free Trial':
        return `background: #EBEBEB;`
      default:
        return `background: linear-gradient(135deg, rgba(249, 225, 180, 0.4) 2.88%, rgba(182, 224, 245, 0.4) 100%);`
    }
  }}
    }

    .current-plan-info {
      padding: 20px 30px 30px 30px;

      .current-plan-frequency {
        color: ${({ theme }) => theme.colors.gray[700]};
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;

        .plan,
        .price {
          font-family: ${({ theme }) => theme.fonts.lexend};
          font-weight: 500;
          font-size: 20px;
        }

        .interval {
          font-family: ${({ theme }) => theme.fonts.nunito};
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
        }
      }

      .current-plan-description {
        font-family: ${({ theme }) => theme.fonts.nunito};
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: ${({ theme }) => theme.colors.gray[500]};
      }
    }
  }

  .upgrade {
    margin: 28px auto 0 auto;
    font-size: 16px;
    letter-spacing: 1px;
  }

  .upgrade {
    font-family: ${({ theme }) => theme.fonts.lexend};
    color: ${({ theme }) => theme.colors.gray[700]};
    padding: 22px 57px;
    border: 1px solid #2e3039;
    border-radius: 3px;
    background: transparent;
    font-weight: 400;
  }

  .unsubscribe {
    font-family: ${({ theme }) => theme.fonts.lexend};
    letter-spacing: 1px;
    border: 0;
    background: transparent;
    margin: -22px 0 0 auto;
    display: block;
  }

  .unsubscribe {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[500]};
  }
`

export default StyledCurrentPlanCard
